import { render, staticRenderFns } from "./imgOrTextMaterial.vue?vue&type=template&id=04025c12&scoped=true"
import script from "./imgOrTextMaterial.vue?vue&type=script&lang=js"
export * from "./imgOrTextMaterial.vue?vue&type=script&lang=js"
import style0 from "./imgOrTextMaterial.vue?vue&type=style&index=0&id=04025c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04025c12",
  null
  
)

export default component.exports